// @flow
import orig from "./original";
import everyday from "./life";

export const original = orig;
export const life = everyday;
export const mixed: string[] = [...original, ...life];
